const Footer = ({ avatarName }) => {
    return (
        <div className="footer" data-testid="footer">
            <h6>Copywrite © 2023 {avatarName}</h6>
        </div>
    )
}

export default Footer
